module.exports = __webpack_public_path__ + "media/images/logo-inverse-5c98467662620d074a2aaa582e028e09.png";